import { ReactNode, createContext, useContext } from 'react';
// import { useImmer, useImmerReducer } from 'use-immer';
import { useImmer } from 'use-immer';
// import { produce, applyPatches } from 'immer';
import { nothing } from 'immer';
// import { useCallbackRef } from '@radix-ui/react-use-callback-ref';
import { useStore, useStoreApi } from '@tmsw/powerups.store';
// import type { HexStateProps } from '../../components/HexGrid/models/Hex';
// import reducer from './reducer';
import {
  //   Hex,
  //   HexCoordinates,
  calculateCoordinates,
  LAYOUT_FLAT,
  LAYOUT_POINTY,
} from '../../components/HexGrid';

let LevelContext = createContext<any>({} as any);

// @ts-ignore
export function LevelProvider({ pieces, board, children }) {
  const { size, flat, spacing, origin } = board;

  const orientation = flat ? LAYOUT_FLAT : LAYOUT_POINTY;
  const angle = board.flat ? 0 : Math.PI / 6;
  const cornerCoords = calculateCoordinates(board.size.x, angle);
  const points = cornerCoords.map((point) => `${point.x},${point.y}`).join(' ');
  const layout = {
    orientation,
    size,
    origin,
    spacing,
  };

  let initialState = {
    pieces,
    board,
    layout,
    points,
    metadata: {
      selected: undefined as any,
      focused: undefined as any,
    },
  };

  const [state, updateLevel] = useImmer(() => {
    return initialState;
  });

  console.info('LevelProvider :: state=', state);

  const updateItem = ({ piece }: any) => {
    console.log('Updating....', piece);
    updateLevel((draft) => {
      const updateIndex = draft.pieces.findIndex((o: any) => o.id === piece.id);
      console.log(updateIndex);
      draft.pieces[updateIndex] = { ...draft.pieces[updateIndex], ...piece };
    });
  };

  const setSelectedItem = ({ id }: any) => {
    console.log('setSelectedItem....', id);
    updateLevel((draft) => {
      const piece = draft.pieces.find((o: any) => o.id === id);
      // console.log(updateIndex);
      draft.metadata.selected = piece;
    });
  };

  const clearSelectedItem = () => {
    console.log('clearSelectedItem....');
    updateLevel((draft) => {
      draft.metadata.selected = false;
    });
  };

  return (
    <LevelContext.Provider
      value={{
        state,
        actions: {
          updateLevel: updateLevel,
          updateItem: updateItem,
          setSelectedItem: setSelectedItem,
          clearSelectedItem: clearSelectedItem,
        },
      }}
    >
      {children}
    </LevelContext.Provider>
  );
}

export const useLevelContext = () => useContext(LevelContext);
